module.exports = {"yytx13":{"daobanList":[{"title":"1:是否办理社会化管理退休人员领取养老待遇资格认证","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、身份证或社保卡原件","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx13.json
// module id = 1312
// module chunks = 0